/** Shared helpers for monthly LLM $ budget UX. */

export const LLM_QUOTA_EXHAUSTED_MESSAGE =
  "Your monthly AI budget is used up. Ask, enrichment, and other AI features are paused until next month — or ask your administrator to raise the allowance.";

export function readTrialStatusFromStorage() {
  try {
    const raw = localStorage.getItem("trialStatus");
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data && typeof data === "object" ? data : null;
  } catch {
    return null;
  }
}

export function readLlmQuota(trial = readTrialStatusFromStorage()) {
  const q = trial?.llm_quota;
  if (!q || typeof q !== "object") return null;
  const allowance = Number(q.monthly_allowance_usd);
  const remaining = Number(q.remaining_usd);
  if (!Number.isFinite(allowance)) return null;
  return {
    allowance,
    remaining: Number.isFinite(remaining) ? Math.max(0, remaining) : allowance,
    used: Number(q.used_usd) || 0,
    enforce: Boolean(q.enforce),
  };
}

/** True when enforcement is on and remaining estimated spend is exhausted. */
export function isLlmQuotaExhausted(trial = readTrialStatusFromStorage()) {
  const llm = readLlmQuota(trial);
  if (!llm || !llm.enforce) return false;
  return llm.remaining <= 0.000001 || llm.used >= llm.allowance;
}

export function formatUsd(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return `$${n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** Prefer FastAPI `detail` (incl. 429 quota) over generic Axios status text. */
export function apiErrorMessage(err, fallback = "Request failed") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail.trim();
  if (Array.isArray(detail) && detail[0]?.msg) return String(detail[0].msg);
  if (typeof err?.message === "string" && err.message.trim()) return err.message.trim();
  return fallback;
}
